import preloader from "./Preloader";
import axios from "axios";

class ApplicationForm {
    static init($context = null) {
        var selector = "[data-application-type='application']";
        let $containers = $context ? $context.find(selector) : $(selector);

        $containers.each(function (index, element) {
            if ($(element).data('application_form_instance')) return;
            $(element).data('application_form_instance', new ApplicationForm(element))
        });
    }

    checkDataTimeoutId = null
    poCheckDataTimeoutId = null
    currentProgress = 0
    lastLoadedDataKey = null

    constructor(element) {
        this.version = '0.0.1'
        this.element = element;
        this.$element = $(element);
        this.$poLegalFormInput = this.$element.find('[name*="[POLegalForm]"]');
        this.$politicalComiteeTypeInput = this.$element.find('[name*="[PoliticalComiteeType]"]');
        this.$poCountryInput = this.$element.find('[name*="[Address:po][country]"]');
        this.$poMunicipalityInput = this.$element.find('[name*="[Address:po][municipality]"]');

        this.$EstablishedPoliticalOrganisationTitleInput = this.$element.find('[name*="[EstablishedPoliticalOrganisationTitle]"]');
        this.$POTitleJarReservationIDInput = this.$element.find('[name*="[POTitleJarReservationID]"]');

        this.$politicalComiteeTypeInput.on('change', function (){
            this.checkPoliticalCommitteeTypeConditions()
        }.bind(this))
        this.$poLegalFormInput.on('change', function (){
            this.checkPoliticalCommitteeTypeConditions()
        }.bind(this))
        this.checkPoliticalCommitteeTypeConditions()


        //this.$EstablishedPoliticalOrganisationTitleInput.on('change', this.onPOTitleSourceValueChange.bind(this))
        this.$POTitleJarReservationIDInput.on('change', this.onPOTitleSourceValueChange.bind(this))
    }

    checkPoliticalCommitteeTypeConditions(){
        let poLegalCode = this.$poLegalFormInput.val()
        if(poLegalCode !== 'pk'){
            this.allowAnyCountry()
            return;
        }
        let code = this.$politicalComiteeTypeInput.val()
        if(code !== 'stmr'){
            this.allowAnyCountry()
            return;
        }

        this.allowOnlyLocalCountry()
    }

    onPOTitleSourceValueChange() {

        clearTimeout(this.poCheckDataTimeoutId)
        if (!this.$EstablishedPoliticalOrganisationTitleInput.val() || !this.$POTitleJarReservationIDInput.val()) return;
        this.poCheckDataTimeoutId = setTimeout(function () {
            this.loadPOTitle();
        }.bind(this), 500)
    }

    loadPOTitle(){

        this.$element.data('loading-additional-data', true)

        axios.get(`${this.basePath()}api/applications/po_title_by_request_no`, {
            params: {
                application: this.$element.find('[name="id"]').val(),
                title: this.$EstablishedPoliticalOrganisationTitleInput.val(),
                requestNo: this.$POTitleJarReservationIDInput.val(),
            }
        }).then( response => {
            if(response.data && response.data.title){
                this.$EstablishedPoliticalOrganisationTitleInput.val(response.data.title).change()
            }
        }).catch( error => {
        }).finally(() => {
            this.$element.data('loading-additional-data', false)
        })

    }

    allowAnyCountry(){
        this.$poCountryInput.attr('readonly', null);
        this.$poCountryInput.data('select2')?.$container.removeClass('select2-container--readonly');
    }
    allowOnlyLocalCountry(){
        this.$poCountryInput.val('LT').trigger('change').attr('readonly', 'readonly');

        this.$poCountryInput.data('select2')?.$container.addClass('select2-container--readonly');
    }
    basePath() {
        if ($('base').length) {
            return '';
        } else {
            return '/'
        }
    }
}


if (typeof module === "object" && typeof module.exports === "object"){

    ApplicationForm.init()
    //node modules support
    module.exports = ApplicationForm;
}else{
    $(function(){
        ApplicationForm.init()
    });
}